import { format } from 'date-fns';
export function dateDisplay(date) {
    if (date) {
        return format(new Date(date), 'MMM dd, yyyy');
    }
    return '';
}
